<template>
<div>
    <!-- {{precision}}
    {{min}}
    {{max}} -->
    <el-input type="number" size="small" autocomplete="off" title="" :disabled="disabled" v-model.trim="ctlVal" @change="changeHandle" @blur="ctlVal = onNumber(ctlVal, p >= 0 ? p : 3)" oninput="if(value<0)value=ctlVal"></el-input>
</div>
</template>

<script>
export default {
    name: "CtlNumber",
    props: {
        // precision: {
        //     type: Object
        // },
        // min: {
        //     type: Object
        // },
        // max: {
        //     type: Object
        // },
        disabled: {},
        p: {},
        //此处一定要用value
        value: {}
    },
    data() {
        return {
            ctlVal: this.value
        }
    },
    // methods: {
    //     onChange() {
    //         this.myValue = '我是由子组件触发改变了内容'
    //     }
    // },
    watch: {
        //监听prop传的value，如果父级有变化了，将子组件的myValue也跟着变，达到父变子变的效果
        value(newVal) {
            this.ctlVal = newVal
        },
        //监听myValue，如果子组件中的内容变化了，通知父级组件，将新的值告诉父级组件，我更新了，父级组件接受到值后页就跟着变了
        //参考官网：https://cn.vuejs.org/v2/guide/components-custom-events.html#%E8%87%AA%E5%AE%9A%E4%B9%89%E7%BB%84%E4%BB%B6%E7%9A%84-v-model
        ctlVal(newVal) {
            this.$emit('input', this.onNumber(newVal, this.p >= 0 ? this.p : 3))
        }
    },
    methods: {
        changeHandle() {
            this.$emit('change')
        },

        //失去焦点是执行
        onNumber(num, limit) {
            var str = String(num)


            if(str === "0.0" || str === "0.00")
            return num;


            if (!str || str.length <2) {
                return parseFloat(str)
            }
            var len1 = str.substr(0, 1)
            var len2 = str.substr(1, 1)
            //如果第一位是0，第二位不是点，就用数字把点替换掉
            if (str.length > 1 && len1 == 0 && len2 != '.') {
                str = str.substr(1, 1)
            }
            //第一位不能是.
            if (len1 == '.') {
                str = ''
            }
            //限制只能输入一个小数点
            if (str.indexOf('.') != -1) {
                var str_ = str.substr(str.indexOf('.') + 1)
                if (str_.indexOf('.') != -1) {
                    str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
                }
            }


            //正则替换
            str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
            if (limit == 0) {
                str = str.replace(/\..*/g, '') // 小数点后只能输 0 位
            } else if (limit == 1) {
                str = str.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/, '$1') // 小数点后只能输 1 位
            } else if (limit == 2) {
                str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1') // 小数点后只能输 2 位
            } else if (limit == 3) {
                str = str.replace(/^\D*([0-9]\d*\.?\d{0,3})?.*$/, '$1') // 小数点后只能输 3 位
            } else if (limit == 4) {
                str = str.replace(/^\D*([0-9]\d*\.?\d{0,4})?.*$/, '$1') // 小数点后只能输 4 位
            } else if (limit == 100) {
                str = str.replace(/^\D*([0-9]\d*\.?\d{0,100})?.*$/, '$1') // 小数点后只能输 100 位
            } //如果想自定义小数点后保留的位数请else if 既可
            return parseFloat(str)
        },
    }
}
</script>
